import { render, staticRenderFns } from "./Plugingoods.vue?vue&type=template&id=27fe6142&scoped=true"
import script from "./Plugingoods.vue?vue&type=script&lang=js"
export * from "./Plugingoods.vue?vue&type=script&lang=js"
import style0 from "./Plugingoods.vue?vue&type=style&index=0&id=27fe6142&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fe6142",
  null
  
)

export default component.exports